module.exports = __webpack_public_path__ + "img/268.9564425b.jpg";